import { render, staticRenderFns } from "./yj.vue?vue&type=template&id=5651c968&scoped=true&"
import script from "./yj.vue?vue&type=script&lang=js&"
export * from "./yj.vue?vue&type=script&lang=js&"
import style0 from "./yj.vue?vue&type=style&index=0&id=5651c968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651c968",
  null
  
)

export default component.exports